import { Button, Divider, Flex, Modal, Space, Table } from "antd";
import { useContext, useEffect, useState } from "react";
import { NotificationContext } from "../../context/notification-provider";
import { useMutation, useQuery } from "@apollo/client";
import { ExclamationCircleFilled } from '@ant-design/icons';
import { RETRIEVE_USER_RESTAURANT } from "../../apollo/query/user.query";
import { selectRestaurant } from "../../store/selectors/user.selector";
import { useSelector } from "react-redux";
import { DELETE_USER_RESTAURANT } from "../../apollo/mutation/user.mutation";
import UserDetail from "../../components/user-detail";

const { confirm } = Modal;

const Users = () => {
    /** Retrieve the restaurant ID */
    const restaurant = useSelector(selectRestaurant);
    /** State to manage the visibility of the subcategory detail */
    const [visible, setVisible] = useState<number | null>(null);
    /** Notification utilities */
    const { showNotification } = useContext(NotificationContext);
    /** Request the list of subcategories */
    const { data } = useQuery(RETRIEVE_USER_RESTAURANT, { variables: { nIDRestaurant: restaurant?.nID } });
    /** Request the deletion of the subcategory */
    const [ deleteUser, { data: responseDeletion } ] = useMutation(DELETE_USER_RESTAURANT, { refetchQueries: ['gqlRetrieveUsersRestaurant']} );
 
    /** Manage to display the alert of deletion succeed */
    useEffect((): void => {
        if( responseDeletion?.code === 200 ) {
            showNotification({ severity: 'success', title: 'Usuari eliminat.' });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [responseDeletion]);
 
    /** Manage to delete the specific subcategory */
    const onDelete = (nID: number): void => {
        confirm({
            title: 'Estàs segur d\'eliminar aquesta usuari?',
            icon: <ExclamationCircleFilled />,
            okText: 'Confirmar',
            onOk() {
                deleteUser({ variables: { nID: nID, nIDRestaurant: restaurant?.nID } });
            },
            cancelText: 'Cancel·lar'
        });
    }
 
    const columns = [
        {
            title: 'Nom',
            dataIndex: 'sName',
            key: 'sName',
            render: (value: string) => <span> { value } </span>
        },
        {
            title: 'Cognom/s',
            dataIndex: 'sSurname',
            key: 'sSurname',
            render: (value: string) => <span> { value } </span>
        },
        {
            title: '',
            key: 'action',
            render: (_: any, record: any) => (
                <Space size="middle">
                    <Button type='text' danger onClick={(evt: any) => {
                        onDelete(record.nID);
                        evt.stopPropagation();
                    }}> Eliminar </Button>
                </Space>
            )
        }
    ];

    return (
        <Flex vertical style={{ backgroundColor: 'white', height: '100%', padding: 10 }}>
            <Flex justify='flex-end'>
                <Button type='primary' onClick={() => setVisible(-1)}> Afegir usuari </Button>
            </Flex>
            <Divider />
            <Flex style={{ width: '100%' }}>
                <Table
                    columns={columns}
                    dataSource={data?.data}
                    rowKey={(record: any) => record.nID}
                    style={{ width: '100%' }}
                    onRow={(record) => {
                        return {
                            onClick: () => setVisible(record.nID)
                        };
                    }}
                    pagination={false}
                />
            </Flex>
            <UserDetail id={visible} visible={visible} setVisible={setVisible} />
        </Flex>
    );
}

export default Users;